import { render } from "./teaStudioHome.vue?vue&type=template&id=77411f62&scoped=true"
import script from "./teaStudioHome.vue?vue&type=script&lang=js"
export * from "./teaStudioHome.vue?vue&type=script&lang=js"

import "./teaStudioHome.vue?vue&type=style&index=0&id=77411f62&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77411f62"]])

export default __exports__